<template>
  <section class="evaluation-item">
    <h3 class="section-title small with-border">
      <v-icon color="deep-orange darken-2">fal fa-camera-alt</v-icon>
      Fotos
    </h3>

    <v-layout row wrap align-center>
      <v-flex xs6 md2 class="photo-item text-xs-center" v-for="(photo, index) in photos" :key="index">
        <v-avatar size="128" color="grey lighten-4">
          <v-progress-circular v-if="loadingPhotoRequest" indeterminate
          color="deep-orange darken-2"></v-progress-circular>
          <div v-if="photo.url && !loadingPhotoRequest" class="image-preview"
            v-bind:style="{ 'background-image': 'url(' + photo.url + ')' }"></div>
        </v-avatar>
        <v-btn round outline color="black" dark v-if="isAdmin"
          v-modal-trigger="'showAdminPhotoGrid'" :data-item="JSON.stringify(photo)">
          <v-icon small left>fal fa-cog</v-icon>
          Prumo
        </v-btn>
        <span class="btn-remove-field" @click="removePhoto(photo)" v-if="photo && photo._id && !isAdmin">
          <v-btn flat icon small color="error">
            <v-icon dark>fal fa-times</v-icon>
          </v-btn>
        </span>
      </v-flex>

      <v-flex xs6 md2 class="photo-item text-xs-center" v-if="!isAdmin">
        <v-progress-circular v-if="loadingPhotoRequest" indeterminate
          color="deep-orange darken-2"></v-progress-circular>
        <photo-upload v-if="!loadingPhotoRequest" accept="image/*" ref="fileInput"
          @input="getUploadedFile($event)"></photo-upload>
      </v-flex>
    </v-layout>

    <br>

    <v-card-actions v-if="!isAdmin">
      <v-spacer></v-spacer>
      <v-btn @click.stop="save()" round large depressed color="success" :loading="loadingRequest">
        <span>ENVIAR AVALIAÇÃO</span>
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </section>
</template>

<script>
import PhotoUpload from '@/modules/PhotoUpload'
import EventBus from '@/event-bus'
import axios from 'axios'
import { Storage } from 'aws-amplify'

export default {
  data: () => ({
    photos: [],
    loadingRequest: false,
    loadingPhotoRequest: false,
    currentUser: {},
    currentEvaluation: {}
  }),

  methods: {
    getUploadedFile (image, index) {
      this.getEvaluation()
      this.loadingPhotoRequest = true
      const path = `users-evaluations/users/${this.currentUser._id}/${this.currentEvaluation._id}/`
      const customPrefix = { public: path }

      Storage.put(this.$moment().unix(), image, { customPrefix }).then(data => {
        const photoURL = `https://s3.amazonaws.com/mentor-fit/users-evaluations/users/${this.currentUser._id}/${this.currentEvaluation._id}/${data.key}`
        this.savePhoto(photoURL)
      })
    },

    savePhoto (url) {
      this.getEvaluation()

      const photoParams = {
        evaluation: this.currentEvaluation._id, url: url, x: '0', y: '0', deg: '0'
      }

      // eslint-disable-next-line
      axios.post(`${API.userEvaluationsPhotos}/user-evaluations/${this.currentEvaluation._id}`, photoParams).then(response => {
        this.loadingPhotoRequest = false
        this.getPhotos()
      }).catch(errors => {
        EventBus.$emit('showSnackbar', { message: 'Erro salvar a foto', color: 'error' })
        this.loadingPhotoRequest = false
      })
    },

    getPhotos () {
      this.getEvaluation()
      this.loadingPhotoRequest = true

      // eslint-disable-next-line
      axios.get(`${API.userEvaluationsPhotos}/user-evaluations/${this.currentEvaluation._id}`).then(response => {
        this.photos = response.data.evaluationPhotos
        this.loadingPhotoRequest = false
      }).catch(errors => {
        EventBus.$emit('showSnackbar', { message: 'Erro carregar as fotos', color: 'error' })
        this.loadingPhotoRequest = false
      })
    },

    removePhoto (photo) {
      this.loadingPhotoRequest = true
      // eslint-disable-next-line
      axios.delete(`${API.userEvaluationsPhotos}/${photo._id}`).then(response => {
        this.loadingPhotoRequest = false
        this.getPhotos()
      }).catch(errors => {
        EventBus.$emit('showSnackbar', { message: 'Erro apagar a foto', color: 'error' })
        this.loadingPhotoRequest = false
      })
    },

    save () {
      if (!this.photos.length) {
        EventBus.$emit('showSnackbar', {
          message: 'A avaliação não pode ficar sem fotos',
          color: 'error'
        })
        return false
      }

      EventBus.$emit('showSnackbar', {
        message: 'Avaliação enviada com sucesso!',
        color: 'success'
      })

      EventBus.$emit('showNewEvaluation', false)
      this.loadingPhotoRequest = false
    },

    getUser () {
      if (!this.user) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'))
      } else {
        this.currentUser = this.user
      }
    },

    getEvaluation () {
      if (this.currentEvaluationPhotos && this.currentEvaluationPhotos._id) { this.currentEvaluation = this.currentEvaluationPhotos }
    },

    watchEvaluation () {
      if (this.currentEvaluationPhotos && this.currentEvaluationPhotos._id) {
        this.getPhotos()
      }
    }
  },

  beforeDestroy () {
    EventBus.$off('loadEvaluationPhoto')
  },

  mounted () {
    this.getUser()

    EventBus.$on('loadEvaluationPhoto', evaluation => {
      this.currentEvaluation = evaluation
    })

    this.getEvaluation()
  },

  watch: {
    'currentEvaluationPhotos': 'watchEvaluation'
  },

  components: { PhotoUpload },

  props: ['currentEvaluationPhotos', 'isAdmin']
}
</script>

<style>
.evaluation-item .v-input.v-text-field {
  padding: 5px 10px;
}

.evaluation-item .photo-item {
  position: relative;
  margin-bottom: 10px;
}

.evaluation-item .photo-item:hover .btn-remove-field {
  display: block;
}

.evaluation-item .photo-item .btn-select-file,
.evaluation-item .photo-item .btn-remove-file {
  display: none;
}

.evaluation-item .v-avatar,
.evaluation-item .v-avatar .image-preview {
  border-radius: 0;
}

.evaluation-item .v-avatar .image-preview {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background-size: cover;
  display: block;
  border: 1px solid #ddd;
}

.evaluation-item .btn-remove-field {
  position: absolute;
  top: -15px;
  color: #fff;
  display: none;
  right: 0;
}

.evaluation-item .btn-remove-field .v-icon {
  position: relative;
  /* top: 10px; */
}
</style>



// WEBPACK FOOTER //
// src/components/user/evaluations/UserEvaluationsItemPhotos.vue